var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _resetTimeouts, _preloadImage, _AddToCartComponent_instances, animateFlyToCart_fn, _abortController, _timeout, _variantChangeInProgress, _addToCartQueue, _ProductFormComponent_instances, updateCartQuantityFromData_fn, fetchAndUpdateCartQuantity_fn, _onCartUpdate, getIntendedVariantId_fn, getQuantity_fn, maxQuantityMessage_fn, showQuantityMessage_fn, hideQuantityMessage_fn, syncMaxReachedState_fn, _onQuantityClamped, processAddToCart_fn, processBatchAddToCart_fn, updateQuantityLabel_fn, setLiveRegionText_fn, clearLiveRegionText_fn, morphOrUpdateElement_fn, _onVariantUpdate, _onVariantSelected;
import { Component } from "@theme/component";
import { fetchConfig, preloadImage, onAnimationEnd, yieldToMainThread } from "@theme/utilities";
import { ThemeEvents, CartAddEvent, CartErrorEvent, CartUpdateEvent, VariantUpdateEvent } from "@theme/events";
import { cartPerformance } from "@theme/performance";
import { morph } from "@theme/morph";
const ERROR_MESSAGE_DISPLAY_DURATION = 1e4;
const ERROR_BUTTON_REENABLE_DELAY = 1e3;
const SUCCESS_MESSAGE_DISPLAY_DURATION = 5e3;
class AddToCartComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _AddToCartComponent_instances);
    __publicField(this, "requiredRefs", ["addToCartButton"]);
    /** @type {number[] | undefined} */
    __privateAdd(
      this,
      _resetTimeouts,
      /** @type {number[]} */
      []
    );
    __privateAdd(this, _preloadImage, () => {
      const image = this.dataset.productVariantMedia;
      if (!image) return;
      preloadImage(image);
    });
    /**
     * Animates the add to cart button.
     */
    __publicField(this, "animateAddToCart", async function() {
      const { addToCartButton } = this.refs;
      if (!__privateGet(this, _resetTimeouts)) {
        __privateSet(this, _resetTimeouts, []);
      }
      __privateGet(this, _resetTimeouts).forEach(
        /** @param {number} timeoutId */
        (timeoutId2) => clearTimeout(timeoutId2)
      );
      __privateSet(this, _resetTimeouts, []);
      if (addToCartButton.dataset.added !== "true") {
        addToCartButton.dataset.added = "true";
      }
      await yieldToMainThread();
      await onAnimationEnd(addToCartButton);
      const timeoutId = setTimeout(() => {
        addToCartButton.removeAttribute("data-added");
        const index = __privateGet(this, _resetTimeouts).indexOf(timeoutId);
        if (index > -1) {
          __privateGet(this, _resetTimeouts).splice(index, 1);
        }
      }, 800);
      __privateGet(this, _resetTimeouts).push(timeoutId);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("pointerenter", __privateGet(this, _preloadImage));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (__privateGet(this, _resetTimeouts)) {
      __privateGet(this, _resetTimeouts).forEach(
        /** @param {number} timeoutId */
        (timeoutId) => clearTimeout(timeoutId)
      );
    }
    this.removeEventListener("pointerenter", __privateGet(this, _preloadImage));
  }
  /**
   * Disables the add to cart button.
   */
  disable() {
    this.refs.addToCartButton.disabled = true;
  }
  /**
   * Enables the add to cart button.
   */
  enable() {
    this.refs.addToCartButton.disabled = false;
  }
  /**
   * Handles the click event for the add to cart button.
   * @param {MouseEvent & {target: HTMLElement}} event - The click event.
   */
  handleClick(event) {
    const form = this.closest("form");
    if (!form?.checkValidity()) return;
    const productForm = (
      /** @type {ProductFormComponent | null} */
      this.closest("product-form-component")
    );
    const quantitySelector = productForm?.refs.quantitySelector;
    if (quantitySelector?.canAddToCart) {
      const validation = quantitySelector.canAddToCart();
      if (!validation.canAdd) {
        return;
      }
    }
    if (this.refs.addToCartButton.dataset.puppet !== "true") {
      const animationEnabled = this.dataset.addToCartAnimation === "true";
      if (animationEnabled && !event.target.closest(".quick-add-modal")) {
        __privateMethod(this, _AddToCartComponent_instances, animateFlyToCart_fn).call(this);
      }
      this.animateAddToCart();
    }
  }
}
_resetTimeouts = new WeakMap();
_preloadImage = new WeakMap();
_AddToCartComponent_instances = new WeakSet();
/**
 * Animates the fly to cart animation.
 */
animateFlyToCart_fn = function() {
  const { addToCartButton } = this.refs;
  const cartIcon = document.querySelector(".header-actions__cart-icon");
  const image = this.dataset.productVariantMedia;
  if (!cartIcon || !addToCartButton || !image) return;
  const flyToCartElement = (
    /** @type {FlyToCart} */
    document.createElement("fly-to-cart")
  );
  let flyToCartClass = addToCartButton.classList.contains("quick-add__button") ? "fly-to-cart--quick" : "fly-to-cart--main";
  flyToCartElement.classList.add(flyToCartClass);
  flyToCartElement.style.setProperty("background-image", `url(${image})`);
  flyToCartElement.style.setProperty("--start-opacity", "0");
  flyToCartElement.source = addToCartButton;
  flyToCartElement.destination = cartIcon;
  document.body.appendChild(flyToCartElement);
};
if (!customElements.get("add-to-cart-component")) {
  customElements.define("add-to-cart-component", AddToCartComponent);
}
class ProductFormComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductFormComponent_instances);
    __publicField(this, "requiredRefs", ["variantId", "liveRegion"]);
    __privateAdd(this, _abortController, new AbortController());
    /** @type {number | undefined} */
    __privateAdd(this, _timeout);
    /** @type {boolean} */
    __privateAdd(this, _variantChangeInProgress, false);
    /** @type {Array<{variantId: string, quantity: number}>} */
    __privateAdd(this, _addToCartQueue, []);
    /**
     * Updates data-cart-quantity when cart is updated from elsewhere
     * @param {CartUpdateEvent|CartAddEvent} event
     */
    __privateAdd(this, _onCartUpdate, async (event) => {
      if (event.detail?.sourceId === this.id || event.detail?.data?.source === "product-form-component") return;
      const cart = (
        /** @type {Cart} */
        event.detail?.resource
      );
      if (cart?.items) {
        __privateMethod(this, _ProductFormComponent_instances, updateCartQuantityFromData_fn).call(this, cart);
      } else {
        await __privateMethod(this, _ProductFormComponent_instances, fetchAndUpdateCartQuantity_fn).call(this);
      }
    });
    /**
     * The quantity input silently snaps a typed value down to what's actually
     * addable, so someone asking for 65 of a 50-limited item gets 50 with no
     * indication anything changed. Say so.
     * @param {Event} event
     */
    __privateAdd(this, _onQuantityClamped, (event) => {
      const detail = (
        /** @type {CustomEvent<{ requested: number, applied: number, max: number | null }>} */
        event.detail
      );
      if (!detail) return;
      __privateMethod(this, _ProductFormComponent_instances, showQuantityMessage_fn).call(this, __privateMethod(this, _ProductFormComponent_instances, maxQuantityMessage_fn).call(this, detail.max));
    });
    /**
     * @param {VariantUpdateEvent} event
     */
    __privateAdd(this, _onVariantUpdate, async (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.detail.data.productId !== this.dataset.productId) {
        return;
      }
      const { variantId } = this.refs;
      variantId.value = event.detail.resource?.id ?? "";
      __privateSet(this, _variantChangeInProgress, false);
      if (__privateGet(this, _addToCartQueue).length > 0) {
        const queuedItems = [...__privateGet(this, _addToCartQueue)];
        __privateSet(this, _addToCartQueue, []);
        __privateMethod(this, _ProductFormComponent_instances, processBatchAddToCart_fn).call(this, queuedItems);
      }
      const { addToCartButtonContainer: currentAddToCartButtonContainer, acceleratedCheckoutButtonContainer } = this.refs;
      const currentAddToCartButton = currentAddToCartButtonContainer?.refs.addToCartButton;
      if (!currentAddToCartButtonContainer || !currentAddToCartButton && !acceleratedCheckoutButtonContainer) return;
      if (event.detail.resource == null || event.detail.resource.available == false) {
        currentAddToCartButtonContainer.disable();
      } else {
        currentAddToCartButtonContainer.enable();
      }
      const newAddToCartButton = event.detail.data.html.querySelector('product-form-component [ref="addToCartButton"]');
      if (newAddToCartButton && currentAddToCartButton) {
        morph(currentAddToCartButton, newAddToCartButton);
      }
      if (acceleratedCheckoutButtonContainer) {
        if (event.detail.resource == null || event.detail.resource.available == false) {
          acceleratedCheckoutButtonContainer?.setAttribute("hidden", "true");
        } else {
          acceleratedCheckoutButtonContainer?.removeAttribute("hidden");
        }
      }
      if (event.detail.resource) {
        const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
        if (productVariantMedia) {
          this.refs.addToCartButtonContainer?.setAttribute(
            "data-product-variant-media",
            productVariantMedia + "&width=100"
          );
        }
      }
      const {
        quantityRules,
        pricePerItem,
        quantitySelector,
        productFormButtons,
        quantityLabel,
        quantitySelectorWrapper
      } = this.refs;
      const newQuantityInput = (
        /** @type {HTMLInputElement | null} */
        event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
      );
      if (quantitySelector?.updateConstraints && newQuantityInput) {
        quantitySelector.updateConstraints(newQuantityInput.min, newQuantityInput.max || null, newQuantityInput.step);
      }
      const newQuantityRules = event.detail.data.html.querySelector(".quantity-rules");
      const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;
      const newPricePerItem = event.detail.data.html.querySelector("price-per-item");
      const isPricePerItemChanging = !!pricePerItem !== !!newPricePerItem;
      if ((isQuantityRulesChanging || isPricePerItemChanging) && quantitySelector) {
        const currentQuantityValue = quantitySelector.getValue?.();
        const newProductFormButtons = event.detail.data.html.querySelector(".product-form-buttons");
        if (productFormButtons && newProductFormButtons) {
          morph(productFormButtons, newProductFormButtons);
          const newQuantityInputElement = (
            /** @type {HTMLInputElement | null} */
            event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
          );
          if (this.refs.quantitySelector?.updateConstraints && newQuantityInputElement && currentQuantityValue) {
            this.refs.quantitySelector.setValue(currentQuantityValue);
            this.refs.quantitySelector.updateConstraints(
              newQuantityInputElement.min,
              newQuantityInputElement.max || null,
              newQuantityInputElement.step
            );
          }
        }
      } else {
        const morphTargets = [
          [".quantity-label", quantityLabel, quantitySelector],
          [".quantity-rules", quantityRules, this.refs.productFormButtons],
          ["price-per-item", pricePerItem, quantitySelectorWrapper]
        ];
        for (const [selector, currentElement, fallback] of morphTargets) {
          __privateMethod(this, _ProductFormComponent_instances, morphOrUpdateElement_fn).call(this, currentElement, event.detail.data.html.querySelector(selector), fallback);
        }
      }
      const currentVolumePricing = this.refs.volumePricing;
      const newVolumePricing = event.detail.data.html.querySelector("volume-pricing");
      __privateMethod(this, _ProductFormComponent_instances, morphOrUpdateElement_fn).call(this, currentVolumePricing, newVolumePricing, this.refs.productFormButtons);
      const hasB2BFeatures = quantityRules || newQuantityRules || pricePerItem || newPricePerItem || currentVolumePricing || newVolumePricing;
      if (!hasB2BFeatures) return;
      await __privateMethod(this, _ProductFormComponent_instances, fetchAndUpdateCartQuantity_fn).call(this);
    });
    /** @param {import('./events').VariantSelectedEvent} _event */
    __privateAdd(this, _onVariantSelected, (_event) => {
      __privateSet(this, _variantChangeInProgress, true);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const { signal } = __privateGet(this, _abortController);
    const target = this.closest(".shopify-section, dialog, product-card");
    target?.addEventListener(ThemeEvents.variantUpdate, __privateGet(this, _onVariantUpdate), { signal });
    target?.addEventListener(ThemeEvents.variantSelected, __privateGet(this, _onVariantSelected), { signal });
    document.addEventListener(ThemeEvents.cartUpdate, __privateGet(this, _onCartUpdate), { signal });
    this.addEventListener("quantityClamped", __privateGet(this, _onQuantityClamped), { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController).abort();
  }
  /** @param {Event} event */
  handleSubmit(event) {
    event.preventDefault();
    if (__privateGet(this, _variantChangeInProgress)) {
      const intendedVariantId = __privateMethod(this, _ProductFormComponent_instances, getIntendedVariantId_fn).call(this);
      const quantity = __privateMethod(this, _ProductFormComponent_instances, getQuantity_fn).call(this);
      if (intendedVariantId) {
        __privateGet(this, _addToCartQueue).push({ variantId: intendedVariantId, quantity });
      }
      this.refs.addToCartButtonContainer?.animateAddToCart?.();
      return;
    }
    __privateMethod(this, _ProductFormComponent_instances, processAddToCart_fn).call(this, void 0, void 0, event);
  }
}
_abortController = new WeakMap();
_timeout = new WeakMap();
_variantChangeInProgress = new WeakMap();
_addToCartQueue = new WeakMap();
_ProductFormComponent_instances = new WeakSet();
/**
 * Updates quantity selector with cart data for current variant
 * @param {Cart} cart - The cart object with items array
 * @returns {number} The cart quantity for the current variant
 */
updateCartQuantityFromData_fn = function(cart) {
  const variantIdInput = (
    /** @type {HTMLInputElement | null} */
    this.querySelector('input[name="id"]')
  );
  if (!variantIdInput?.value || !cart?.items) return 0;
  const cartItem = cart.items.find((item) => item.variant_id.toString() === variantIdInput.value.toString());
  const cartQty = cartItem ? cartItem.quantity : 0;
  const quantitySelector = (
    /** @type {any | undefined} */
    this.querySelector("quantity-selector-component")
  );
  if (quantitySelector?.setCartQuantity) {
    quantitySelector.setCartQuantity(cartQty);
  }
  __privateMethod(this, _ProductFormComponent_instances, updateQuantityLabel_fn).call(this, cartQty);
  __privateMethod(this, _ProductFormComponent_instances, syncMaxReachedState_fn).call(this, cartQty);
  return cartQty;
};
fetchAndUpdateCartQuantity_fn = async function() {
  const variantIdInput = (
    /** @type {HTMLInputElement | null} */
    this.querySelector('input[name="id"]')
  );
  if (!variantIdInput?.value) return null;
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    __privateMethod(this, _ProductFormComponent_instances, updateCartQuantityFromData_fn).call(this, cart);
    return cart;
  } catch (error) {
    console.error("Failed to fetch cart quantity:", error);
    return null;
  }
};
_onCartUpdate = new WeakMap();
/** @returns {string | undefined} */
getIntendedVariantId_fn = function() {
  return new URL(window.location.href).searchParams.get("variant") || this.refs.variantId?.value || void 0;
};
/** @returns {number} */
getQuantity_fn = function() {
  return Number(this.refs.quantitySelector?.getValue?.()) || Number(this.dataset.quantityDefault) || 1;
};
/**
 * Builds the "maximum reached" copy from the theme's own locale string, so
 * every place that reports a quantity limit says the same thing.
 * @param {number | null | undefined} maximum
 * @returns {string}
 */
maxQuantityMessage_fn = function(maximum) {
  return (this.dataset.quantityErrorMax || "").replace("{{ maximum }}", maximum?.toString() || "");
};
/**
 * Shows a quantity message in the add-to-cart error slot and announces it.
 *
 * @param {string} message
 * @param {{ persist?: boolean }} [options] - persist keeps the message up
 *   instead of auto-hiding. Used for the standing "cart already holds the
 *   maximum" state, which stays true until the cart changes, unlike a
 *   one-off rejected submission.
 */
showQuantityMessage_fn = function(message, { persist = false } = {}) {
  const { addToCartTextError } = this.refs;
  if (!addToCartTextError || !message) return;
  addToCartTextError.classList.remove("hidden");
  const textNode = addToCartTextError.childNodes[2];
  if (textNode) {
    textNode.textContent = message;
  } else {
    addToCartTextError.appendChild(document.createTextNode(message));
  }
  __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, message);
  if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  if (persist) return;
  __privateSet(this, _timeout, setTimeout(() => {
    addToCartTextError.classList.add("hidden");
    __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
  }, ERROR_MESSAGE_DISPLAY_DURATION));
};
/** Clears the quantity message, if one is showing. */
hideQuantityMessage_fn = function() {
  const { addToCartTextError } = this.refs;
  if (__privateGet(this, _timeout)) {
    clearTimeout(__privateGet(this, _timeout));
    __privateSet(this, _timeout, null);
  }
  if (!addToCartTextError) return;
  addToCartTextError.classList.add("hidden");
  __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
};
/**
 * Holds the add-to-cart button disabled while the cart already contains the
 * maximum for this variant, rather than letting the click through to a
 * transient disable-and-error cycle that reads as a successful add.
 *
 * Only buttons this method disabled are re-enabled again — tracked with a
 * data attribute — so a button disabled for its own reason (sold out,
 * unavailable variant) is never switched back on here.
 *
 * @param {number} cartQty - Quantity of this variant already in the cart.
 */
syncMaxReachedState_fn = function(cartQty) {
  const quantitySelector = (
    /** @type {any | undefined} */
    this.querySelector("quantity-selector-component")
  );
  const max = quantitySelector?.getCurrentValues?.().max ?? null;
  const atMax = max !== null && cartQty >= max;
  const containers = (
    /** @type {NodeListOf<AddToCartComponent>} */
    this.querySelectorAll("add-to-cart-component")
  );
  for (const container of containers) {
    if (atMax) {
      container.dataset.maxReached = "true";
      container.disable();
    } else if (container.dataset.maxReached === "true") {
      delete container.dataset.maxReached;
      container.enable();
    }
  }
  if (atMax) {
    __privateMethod(this, _ProductFormComponent_instances, showQuantityMessage_fn).call(this, __privateMethod(this, _ProductFormComponent_instances, maxQuantityMessage_fn).call(this, max), { persist: true });
  } else {
    __privateMethod(this, _ProductFormComponent_instances, hideQuantityMessage_fn).call(this);
  }
};
_onQuantityClamped = new WeakMap();
/**
 * @param {string} [overrideVariantId]
 * @param {number} [overrideQuantity]
 * @param {Event} [event]
 */
processAddToCart_fn = function(overrideVariantId, overrideQuantity, event) {
  const { addToCartTextError } = this.refs;
  if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  const allAddToCartContainers = (
    /** @type {NodeListOf<AddToCartComponent>} */
    this.querySelectorAll("add-to-cart-component")
  );
  if (!overrideVariantId) {
    const anyButtonDisabled = Array.from(allAddToCartContainers).some(
      (container) => container.refs.addToCartButton?.disabled
    );
    if (anyButtonDisabled) return;
  }
  const form = this.querySelector("form");
  if (!form) throw new Error("Product form element missing");
  if (!overrideVariantId && this.refs.quantitySelector?.canAddToCart) {
    const validation = this.refs.quantitySelector.canAddToCart();
    if (!validation.canAdd) {
      for (const container of allAddToCartContainers) {
        container.disable();
      }
      __privateMethod(this, _ProductFormComponent_instances, showQuantityMessage_fn).call(this, __privateMethod(this, _ProductFormComponent_instances, maxQuantityMessage_fn).call(this, validation.maxQuantity));
      setTimeout(() => {
        for (const container of allAddToCartContainers) {
          container.enable();
        }
      }, ERROR_BUTTON_REENABLE_DELAY);
      return;
    }
  }
  const formData = new FormData(form);
  if (overrideVariantId) {
    formData.set("id", overrideVariantId);
  }
  if (overrideQuantity !== void 0) {
    formData.set("quantity", overrideQuantity.toString());
  }
  const cartItemsComponents = document.querySelectorAll("cart-items-component");
  let cartItemComponentsSectionIds = [];
  cartItemsComponents.forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      cartItemComponentsSectionIds.push(item.dataset.sectionId);
    }
    formData.append("sections", cartItemComponentsSectionIds.join(","));
  });
  const fetchCfg = fetchConfig("javascript", { body: formData });
  fetch(Theme.routes.cart_add_url, {
    ...fetchCfg,
    headers: {
      ...fetchCfg.headers,
      Accept: "text/html"
    }
  }).then((response) => response.json()).then(async (response) => {
    if (response.status) {
      this.dispatchEvent(
        new CartErrorEvent(form.getAttribute("id") || "", response.message, response.description, response.errors)
      );
      if (!addToCartTextError) return;
      addToCartTextError.classList.remove("hidden");
      const textNode = addToCartTextError.childNodes[2];
      if (textNode) {
        textNode.textContent = response.message;
      } else {
        const newTextNode = document.createTextNode(response.message);
        addToCartTextError.appendChild(newTextNode);
      }
      __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, response.message);
      __privateSet(this, _timeout, setTimeout(() => {
        if (!addToCartTextError) return;
        addToCartTextError.classList.add("hidden");
        __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
      }, ERROR_MESSAGE_DISPLAY_DURATION));
      this.dispatchEvent(
        new CartAddEvent({}, this.id, {
          didError: true,
          source: "product-form-component",
          itemCount: Number(formData.get("quantity")) || Number(this.dataset.quantityDefault),
          productId: this.dataset.productId
        })
      );
      return;
    } else {
      const id = formData.get("id");
      if (addToCartTextError) {
        addToCartTextError.classList.add("hidden");
        addToCartTextError.removeAttribute("aria-live");
      }
      if (!id) throw new Error("Form ID is required");
      const anyAddToCartButton = allAddToCartContainers[0]?.refs.addToCartButton;
      if (anyAddToCartButton) {
        const addedTextElement = anyAddToCartButton.querySelector(".add-to-cart-text--added");
        const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;
        __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, addedText);
        setTimeout(() => {
          __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
        }, SUCCESS_MESSAGE_DISPLAY_DURATION);
      }
      const cart = await __privateMethod(this, _ProductFormComponent_instances, fetchAndUpdateCartQuantity_fn).call(this);
      this.dispatchEvent(
        new CartAddEvent(cart ?? void 0, id.toString(), {
          source: "product-form-component",
          itemCount: Number(formData.get("quantity")) || Number(this.dataset.quantityDefault),
          productId: this.dataset.productId,
          sections: response.sections
        })
      );
    }
  }).catch((error) => {
    console.error(error);
  }).finally(() => {
    if (event) {
      cartPerformance.measureFromEvent("add:user-action", event);
    }
  });
};
/** @param {Array<{variantId: string, quantity: number}>} items */
processBatchAddToCart_fn = function(items) {
  if (items.length === 0) return;
  const { addToCartTextError } = this.refs;
  if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  const cartItemsComponents = document.querySelectorAll("cart-items-component");
  const cartItemComponentsSectionIds = [];
  for (const item of cartItemsComponents) {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      cartItemComponentsSectionIds.push(item.dataset.sectionId);
    }
  }
  const payload = {
    items: items.map((item) => ({
      id: Number(item.variantId),
      quantity: item.quantity
    })),
    sections: cartItemComponentsSectionIds.join(",")
  };
  fetch(Theme.routes.cart_add_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(payload)
  }).then((response) => response.json()).then(async (response) => {
    if (response.status) {
      this.dispatchEvent(
        new CartErrorEvent(this.id, response.message, response.description, response.errors)
      );
      if (addToCartTextError) {
        addToCartTextError.classList.remove("hidden");
        const textNode = addToCartTextError.childNodes[2];
        if (textNode) {
          textNode.textContent = response.message;
        } else {
          addToCartTextError.appendChild(document.createTextNode(response.message));
        }
        __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, response.message);
        __privateSet(this, _timeout, setTimeout(() => {
          addToCartTextError.classList.add("hidden");
          __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
        }, ERROR_MESSAGE_DISPLAY_DURATION));
      }
      this.dispatchEvent(
        new CartAddEvent({}, this.id, {
          didError: true,
          source: "product-form-component",
          itemCount: items.reduce((sum, item) => sum + item.quantity, 0),
          productId: this.dataset.productId
        })
      );
      return;
    }
    if (addToCartTextError) {
      addToCartTextError.classList.add("hidden");
      addToCartTextError.removeAttribute("aria-live");
    }
    const allAddToCartContainers = (
      /** @type {NodeListOf<AddToCartComponent>} */
      this.querySelectorAll("add-to-cart-component")
    );
    const anyAddToCartButton = allAddToCartContainers[0]?.refs.addToCartButton;
    if (anyAddToCartButton) {
      const addedTextElement = anyAddToCartButton.querySelector(".add-to-cart-text--added");
      const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;
      __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, addedText);
      setTimeout(() => __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this), SUCCESS_MESSAGE_DISPLAY_DURATION);
    }
    const cart = await __privateMethod(this, _ProductFormComponent_instances, fetchAndUpdateCartQuantity_fn).call(this);
    const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
    this.dispatchEvent(
      new CartAddEvent(cart ?? void 0, this.id, {
        source: "product-form-component",
        itemCount: totalQuantity,
        productId: this.dataset.productId,
        sections: response.sections
      })
    );
  }).catch((error) => {
    console.error(error);
  });
};
/**
 * Updates the quantity label with the current cart quantity
 * @param {number} cartQty - The quantity in cart
 */
updateQuantityLabel_fn = function(cartQty) {
  const quantityLabel = this.refs.quantityLabelCartCount;
  if (quantityLabel) {
    const inCartText = quantityLabel.textContent?.match(/\((\d+)\s+(.+)\)/);
    if (inCartText && inCartText[2]) {
      quantityLabel.textContent = `(${cartQty} ${inCartText[2]})`;
    }
    quantityLabel.classList.toggle("hidden", cartQty === 0);
  }
};
/**
 * @param {*} text
 */
setLiveRegionText_fn = function(text) {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = text;
};
clearLiveRegionText_fn = function() {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = "";
};
/**
 * Morphs or removes/adds an element based on current and new element states
 * @param {Element | null | undefined} currentElement - The current element in the DOM
 * @param {Element | null | undefined} newElement - The new element from the server response
 * @param {Element | null} [insertReferenceElement] - Element to insert before if adding new element
 */
morphOrUpdateElement_fn = function(currentElement, newElement, insertReferenceElement = null) {
  if (currentElement && newElement) {
    morph(currentElement, newElement);
  } else if (currentElement && !newElement) {
    currentElement.remove();
  } else if (!currentElement && newElement && insertReferenceElement) {
    insertReferenceElement.insertAdjacentElement(
      "beforebegin",
      /** @type {Element} */
      newElement.cloneNode(true)
    );
  }
};
_onVariantUpdate = new WeakMap();
_onVariantSelected = new WeakMap();
if (!customElements.get("product-form-component")) {
  customElements.define("product-form-component", ProductFormComponent);
}
export {
  AddToCartComponent
};
